import React from 'react';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { TOGGLE_COMMENT_LIKE } from '../../graphql/TOGGLE_COMMENT_LIKE';
import { GET_CURRENT_USER_me } from '../../graphql/types/GET_CURRENT_USER';
import { TOGGLE_UPDATE_COMMENT_LIKE } from '../../graphql/TOGGLE_UPDATE_COMMENT_LIKS';
import { CommentCategory } from './constants';
export interface IComment {
    commentId: string,
}

interface ILikeComment {
    commentId: string,
    commentCategory?: CommentCategory,
    likes: {
        author: {
          id: string,
          profile: {
            id: string,
            name: string,
            __typename: string
          }
        }
    }[],
    user: GET_CURRENT_USER_me;
}

const LikeComment: React.FunctionComponent<ILikeComment> = ({ commentId, commentCategory, likes = [], user }: ILikeComment) => {
    const isOwner = Boolean(likes.find((like) => like.author.id === user.id));
    const likeCount = likes.length;

    const [toggleCommentLike] = useMutation(TOGGLE_COMMENT_LIKE, {
        variables: {
            commentId
        },
        refetchQueries: commentCategory === CommentCategory.projectListing? ['GET_ALL_PROJECTS']: ['GET_PROJECT']
    });

    const [toggleUpdateCommentLike] = useMutation(TOGGLE_UPDATE_COMMENT_LIKE, {
        variables: {
            commentId: typeof commentId === 'string'? parseInt(commentId, 10): commentId
        },
        refetchQueries: ['GET_PROJECT']
    });

    const handleLike = async () => {
        if (commentCategory === CommentCategory.project || commentCategory === CommentCategory.projectListing) {
            await toggleCommentLike();
        } else if (commentCategory === CommentCategory.projectUpdate) {
            await toggleUpdateCommentLike()
        } else {
            toast.error(
              'There is something wrong happen when you like ...!'
            );
        }
    }

    return (
        <button
            onClick={handleLike}
            className="comment-like-button"
        >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="comment-like-icon">
                <path
                    d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill={isOwner ? '#5775FF' : 'none'}
                />
            </svg>
            {likeCount > 0 && (
                <span className={isOwner ? 'comment-like-count is-active' : 'comment-like-count'}>
                    {likeCount} {likeCount === 1 ? 'Like' : 'Likes'}
                </span>
            )}
        </button>
    );
}

export default LikeComment;